<script lang="ts">

    export let icon: string;
    export let text: string;

</script>

<style lang="scss">

    @use '../variables';

    button {
        border: none;
        background-color: #fff;
        border-radius: 1000rem;
        display: flex;
        align-items: center;
        color: variables.$answer-win-color;
        padding: 0.5rem 1rem;
        font-size: 1.5rem;
        gap: 0.5rem;

        img {
            width: 1.5rem;
            height: 1.5rem;
        }
    }

</style>

<button class="shadow" type="button" on:click>
    <!-- svelte-ignore a11y-missing-attribute -->
    <img src={icon} /> {text}
</button>

